import script from "./Rate.vue?vue&type=script&setup=true&lang=js"
export * from "./Rate.vue?vue&type=script&setup=true&lang=js"

import "./Rate.vue?vue&type=style&index=0&id=2eca39f0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eca39f0"]])

export default __exports__